module.exports = __webpack_public_path__ + "static/img/response0.83cc543.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/response0.png
// module id = f6sv
// module chunks = 0